import {Injectable} from "@angular/core";
import {LocalForageService} from "ngx-localforage";
import {Article} from "../data/article";
import {ApiService} from "./api";


/**
 * App service
 */


export class CartItems {
    key: string = 'items';
    value: any = [];
}

@Injectable()
export class CartService {
    public items: any = {};
    public shipments: any = [];
    public shippings: any = [];

    protected _countries = [];
    protected _shipment: any = null;

    public shippingPrice: number = 0.0;
    public totalPrice: number = 0.0;

    constructor(public storage: LocalForageService, public api: ApiService) {
        this.refreshShipments();
        storage.getItem('items').subscribe((items) => {
            if (items) {
                this.items = items;
            }
        })
    }

    public set shipment(value: any) {
        this._shipment = value;
    }

    public get countries(): any[] {
        if(this._countries.length) return this._countries;
        this._countries = [
            {
                "key":"AT",/**/
                "text":"Österreich"
            },
            {
                "key":"DE",/**/
                "text":"Deutschland"
            },
            {
                "key":"CH",/**/
                "text":"Schweiz"
            },
            {
                "key":"BE",/**/
                "text":"Belgien"
            },
            {
                "key":"BG",/**/
                "text":"Bulgarien"
            },
            {
                "key":"DK",/**/
                "text":"Dänemark"
            },
            {
                "key":"UK",/**/
                "text":"England"
            },
            {
                "key":"EE",/**/
                "text":"Estland"
            },
            {
                "key":"FI",/**/
                "text":"Finnland"
            },
            {
                "key":"FR",/**/
                "text":"Frankreich"
            },
            {
                "key":"GR",/**/
                "text":"Griechenland"
            },
            {
                "key":"IE",/**/
                "text":"Irland"
            },
            {
                "key":"IT",/**/
                "text":"Italien"
            },
            {
                "key":"HR",/**/
                "text":"Kroatien"
            },
            {
                "key":"LV",/**/
                "text":"Lettland"
            },
            {
                "key":"LT",/**/
                "text":"Litauen"
            },
            {
                "key":"LU",/**/
                "text":"Luxemburg"
            },
            {
                "key":"MT",/**/
                "text":"Malta"
            },
            {
                "key":"NL",/**/
                "text":"Niederlande"
            },
            {
                "key":"PL",/**/
                "text":"Polen"
            },
            {
                "key":"PT",/**/
                "text":"Portugal"
            },
            {
                "key":"RO",/**/
                "text":"Rumänien"
            },
            {
                "key":"SE",/**/
                "text":"Schweden"
            },
            {
                "key":"SK",/**/
                "text":"Slowakei"
            },
            {
                "key":"SL",/**/
                "text":"Slowenien"
            },
            {
                "key":"ES",/**/
                "text":"Spanien"
            },
            {
                "key":"CZ",/**/
                "text":"Tschechische Republik"
            },
            {
                "key":"HU",/**/
                "text":"Ungarn"
            },
            {
                "key":"CY",/**/
                "text":"Zypern"
            }
        ]

        return this._countries;
    }

    public refreshShipments(): Promise<any> {
        return this.api.call('/article/index/shipments', {}, "", false, false, true).then((result) => {
            this.shipments = [];
            let shippings = result;
            this.shippings = shippings;
            for (let key of Object.keys(shippings)) {
                if (!this._shipment) {
                    this._shipment = key;
                }
                this.shipments.push(shippings[key]);
            }
        })
    }

    public getTotal(): number {
        let count = 0;
        this.getItems().forEach((i) => {
            count += i.count
        })
        return count;
    }

    public getItems(): any[] {
        let obj = [];
        for (let key of Object.keys(this.items)) {
            obj.push(this.items[key]);
        }
        return obj;
    }

    public clear(): void {
        this.items = {};
        this.save();
    }

    public removeItem(id): boolean {
        if (this.items.hasOwnProperty(id)) {
            delete this.items[id];
            this.save();
            return true;
        }

        return false;
    }

    public removeColor(id, index): boolean {
        if (this.items.hasOwnProperty(id)) {
            this.items[id].colors.splice(index, 1);
            this.items[id].count--;

            if (this.items[id].count == 0) {
                return this.removeItem(id);
            }
            this.save();
            return true;
        }
        return false;
    }

    public getTotalPrice(shipment, payment) {
        payment = payment || false;
        let obj = null, sum = 0.0;
        for (let key of Object.keys(this.items)) {
            obj = this.items[key];
            sum = sum + (obj.count * obj.article.price);
        }

        if (shipment) {
            sum = sum + this.getShippingPrice(null);
        }

        if (payment && payment.fee > 0) {
            sum = sum + (sum / 100 * payment.fee);
        }

        return Math.round(sum * 100) / 100;
    }

    public getShippingPrice(address): number {
        let obj = null, sum = 0.0, s = null;

        if(address && address.country) {
            this._shipment = address.country;
        }

        if (!this._shipment || this.shippings.length == 0) return 0.0;
        switch (this._shipment) {
            case 'AT':
            case 'DE':
            case 'CH':
                s = this._shipment;
                break;
            default:
                s = 'EUROPE';
                break;
        }
        let shipment = this.shippings[s];
        for (let key of Object.keys(this.items)) {
            obj = this.items[key];

            sum = sum + (obj.count * shipment['categories'][obj.article.shipment_class]);
        }
        this.shippingPrice = sum;
        return Math.round(sum * 100) / 100;
    }

    public save(): void {
        this.storage.setItem('items', this.items)
    }

    public addItem(item: Article, amount: number, color: string) {
        if (this.items.hasOwnProperty(item.article_id)) {
            this.items[item.article_id].count += amount;
        } else {
            this.items[item.article_id] = {
                count: amount,
                article: item,
                colors: []
            };
        }
        for (let i = 0; i < amount; i++) {
            this.items[item.article_id].colors.push(color);
        }

        this.save();
    }
}



// WEBPACK FOOTER //
// ./src/app/service/cart.ts